module.exports = __webpack_public_path__ + "static/media/Battery&Bulb1.d8e49625.png";